import React, { useRef, useState } from "react";
import { Modal, Form, InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import styled from "styled-components";
import { Box, ButtonStyled, SpanStyled } from "../../styled/Elements";
// import {
//   FacebookShareButton,
//   TwitterShareButton,
//   WhatsappShareButton,
//   LinkedinShareButton,
//   FacebookIcon,
//   TwitterIcon,
//   WhatsappIcon,
//   LinkedinIcon,
// } from "react-share";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon,
  InstapaperIcon,
} from "react-share";
import { FaXTwitter, FaSnapchat, FaInstagram } from "react-icons/fa6";

const StyledInput = styled(Form.Control)`
  background-color: #f8f9f0;
  cursor: not-allowed;
`;
const SocialShareContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
`;

const SocialButton = styled.div`
  margin: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }
`;

const SocialLabel = styled.span`
  font-size: 14px;
  margin-top: 5px;
  color: var(--text2);
`;
const CustomIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor || "#000"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

const ShareModal = ({ show, handleClose, cardLink }) => {
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const [shareTitle] = useState("Check out this profile");

  const copyToClipboard = () => {
    if (inputRef.current) {
      navigator.clipboard.writeText(cardLink);
      toast.success(t("url_copied_successfully"), {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      });
    }
  };

  // const shareToInstagram = () => {
  //   // Instagram doesn't support direct URL sharing, so we'll copy to clipboard
  //   navigator.clipboard.writeText(cardLink);
  //   toast.info(t("instagram_share_instructions"), {
  //     position: "top-center",
  //     autoClose: 3000,
  //     hideProgressBar: true,
  //   });
  // };

  // Snapchat sharing via their share sheet
  const shareToSnapchat = () => {
    window.open(
      `https://www.snapchat.com/scan?attachmentUrl=${encodeURIComponent(
        cardLink
      )}`,
      "_blank"
    );
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("share_profile")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="py-3">
          <Form.Label>{t("profile_link")}</Form.Label>
          <InputGroup>
            <StyledInput ref={inputRef} type="text" value={cardLink} disabled />
          </InputGroup>
          <Box className="w-100 d-flex justify-content-end">
            <ButtonStyled
              className="mt-2"
              variant="primary"
              label={t("copy_link")}
              bg="var(--themeColorSecondary)"
              onClick={copyToClipboard}
            />
          </Box>
        </Form.Group>

        <hr />

        <div className="">
          <SpanStyled className="mb-2">{t("share_on_social")}</SpanStyled>
          <SocialShareContainer>
            <FacebookShareButton url={cardLink} quote={shareTitle}>
              <SocialButton>
                <FacebookIcon size={40} round />
                <SocialLabel>{t("facebook")}</SocialLabel>
              </SocialButton>
            </FacebookShareButton>

            <TwitterShareButton url={cardLink} title={shareTitle}>
              <SocialButton>
                <CustomIconWrapper bgColor="#000">
                  <FaXTwitter size={20} />
                </CustomIconWrapper>
                <SocialLabel>{t("twitter")}</SocialLabel>
              </SocialButton>
            </TwitterShareButton>

            <LinkedinShareButton url={cardLink} title={shareTitle}>
              <SocialButton>
                <LinkedinIcon size={40} round />
                <SocialLabel>{t("linkedin")}</SocialLabel>
              </SocialButton>
            </LinkedinShareButton>

            <WhatsappShareButton url={cardLink} title={shareTitle}>
              <SocialButton>
                <WhatsappIcon size={40} round />
                <SocialLabel>{t("whatsapp")}</SocialLabel>
              </SocialButton>
            </WhatsappShareButton>

            {/* <SocialButton onClick={shareToInstagram}>
              <CustomIconWrapper bgColor="#E1306C">
                <FaInstagram size={20} />
              </CustomIconWrapper>
              <SocialLabel>{t("instagram")}</SocialLabel>
            </SocialButton> */}

            <SocialButton onClick={shareToSnapchat}>
              <CustomIconWrapper bgColor="#FFFC00">
                <FaSnapchat
                  size={20}
                  color="#000"
                  style={{
                    fontWeight: "bold",
                    filter: "drop-shadow(0 0 1px white)",
                  }}
                />
              </CustomIconWrapper>
              <SocialLabel>{t("snapchat")}</SocialLabel>
            </SocialButton>

            <EmailShareButton
              url={cardLink}
              subject={shareTitle}
              body={t("email_share_body")}
            >
              <SocialButton>
                <EmailIcon size={40} round />
                <SocialLabel>{t("email")}</SocialLabel>
              </SocialButton>
            </EmailShareButton>
          </SocialShareContainer>
          {/* <div className="d-flex justify-content-center gap-2 flex-wrap">
            <FacebookShareButton url={cardLink}>
              <FacebookIcon size={40} round />
            </FacebookShareButton>
            <FacebookShareButton url={cardLink}>
              <FacebookIcon size={40} round />
            </FacebookShareButton>
            <TwitterShareButton url={cardLink}>
              <TwitterIcon size={40} round />
            </TwitterShareButton>
            <WhatsappShareButton url={cardLink}>
              <WhatsappIcon size={40} round />
            </WhatsappShareButton>
            <LinkedinShareButton url={cardLink}>
              <LinkedinIcon size={40} round />
            </LinkedinShareButton>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;

// import React, { useState, useRef } from "react";
// import { Modal, Button, Form, InputGroup } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import styled from "styled-components";
// import { Box, ButtonStyled, TextStyled } from "../../styled/Elements";

// const StyledInput = styled(Form.Control)`
//   background-color: #f8f9f0;
//   cursor: not-allowed;
// `;

// const ShareModal = ({ show, handleClose, cardLink }) => {
//   const inputRef = useRef(null);
//   const { t } = useTranslation();

//   const copyToClipboard = () => {
//     if (inputRef.current) {
//       navigator.clipboard.writeText(cardLink);
//       toast.success(t("url_copied_successfully"), {
//         position: "top-center",
//         autoClose: 2000,
//         hideProgressBar: true,
//         closeOnClick: true,
//         pauseOnHover: false,
//         draggable: true,
//         // theme: "colored",
//       });
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>{t("share_profile")}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form.Group className="py-3">
//           <Form.Label>{t("profile_link")}</Form.Label>
//           <InputGroup>
//             <StyledInput ref={inputRef} type="text" value={cardLink} disabled />
//           </InputGroup>
//           <Box className="w-100 d-flex justify-content-end">
//             <ButtonStyled
//               className="mt-2"
//               variant="primary"
//               label={t("copy_link")}
//               bg="var(--themeColorSecondary)"
//               onClick={copyToClipboard}
//             />
//           </Box>
//         </Form.Group>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default ShareModal;
